<div class="tratamiento-dialog">
  <mat-card class="tratamiento-card">
    <!-- Header -->
    <mat-card-header
      class="irx-sobre-color tratamiento-header"
      [style.background-color]="data?.valores?.color"
      [style.color]="helper.colorDeTextoSegunColor(data?.valores?.color)"
    >
      <!-- [cdkDragBoundary]="dragBoundary" -->
      <mat-card-title
        [cdkDragDisabled]="loading || !dragBoundary"
        cdkDrag
        cdkDragHandle
        cdkDragRootElement=".cdk-overlay-pane"
        (cdkDragStarted)="bringToFront()"
        class="tratamiento-title"
      >
        <!-- Titulo evento y cliente -->
        <div class="header-main-info">
          <mat-icon class="header-icon">notification_important</mat-icon>
          <div class="header-text">
            <span class="header-title">{{ data?.valores.titulo }}</span>
            <span class="header-subtitle">
              {{
                data?.alarma?.nombre ||
                  data?.activo?.identificacion ||
                  data?.tracker?.nombre ||
                  data?.luminaria?.identificacion ||
                  data?.sirena?.chipId ||
                  data?.gateway?.nombre
              }}
              · {{ data?.cliente?.nombre }}
            </span>
          </div>
        </div>

        <!-- Estado de cuenta y servicios -->
        <div class="header-metadata">
          <!-- Servicio técnico activo -->
          @if (servicioTecnicoActivo) {
            <mat-icon
              style="cursor: default"
              class="status-icon"
              [tooltip]="
                'Servicio Técnico: ' +
                estadoServicioTecnico +
                (servicioTecnicoActivo.detallesTecnicos?.tecnico
                  ?.datosPersonales?.nombre
                  ? ' - ' +
                    servicioTecnicoActivo.detallesTecnicos.tecnico
                      .datosPersonales.nombre
                  : servicioTecnicoActivo.detallesTecnicos?.tecnico?.usuario
                    ? ' - ' +
                      servicioTecnicoActivo.detallesTecnicos.tecnico.usuario
                    : '')
              "
            >
              build
            </mat-icon>
          }

          <!-- Modo desactivado -->
          @if (dispositivoEnModoDesactivado) {
            <mat-icon
              style="cursor: default"
              class="status-icon"
              tooltip="Dispositivo en modo desactivado"
            >
              do_not_disturb_on
            </mat-icon>
          }

          <!-- Estado de cuenta (solo alarma/activo/tracker) -->
          @if (estadoDeCuenta && aplicaEstadoCuentaYServicios) {
            <mat-icon
              style="cursor: default"
              class="status-icon"
              [tooltip]="'Estado de cuenta: ' + estadoDeCuenta"
            >
              account_balance_wallet
            </mat-icon>
          }

          <!-- Servicios (solo alarma/activo/tracker) -->
          @let servicios =
            evento?.alarma?.idServiciosContratados ||
            evento?.activo?.tracker?.idServiciosContratados ||
            evento?.tracker?.idServiciosContratados;

          @if (aplicaEstadoCuentaYServicios) {
            @if (servicios) {
              <app-mostrar-servicios
                [idsServicios]="servicios"
                [linea]="true"
                [size]="22"
                [rounded]="true"
              ></app-mostrar-servicios>
            } @else {
              <mat-icon
                style="cursor: default"
                class="status-icon"
                tooltip="Sin Servicios"
              >
                inbox
              </mat-icon>
            }
          }
        </div>

        <!-- Minimizar -->
        <button
          irxBotonIcono
          class="icon-close"
          (click)="minimizar(); $event.stopPropagation()"
          tooltip="Minimizar"
          aria-label="Minimizar diálogo"
        >
          <mat-icon>remove</mat-icon>
        </button>
        <!-- Cerrar -->
        <button
          irxBotonIcono
          class="icon-close"
          (click)="closeDialog()"
          tooltip="Cerrar"
          aria-label="Cerrar diálogo"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-card-title>
    </mat-card-header>

    <!-- Loading -->
    @if (loading) {
      <div class="loading-container">
        <mat-spinner color="primary"></mat-spinner>
        <p class="loading-text">Cargando información del evento...</p>
      </div>
    } @else {
      <!-- Content -->
      @if (!esEventoTecnico()) {
        <mat-card-content class="tratamiento-content">
          <!-- Información del evento -->
          <div class="evento-info-section">
            <div class="info-cards-container">
              <!-- Card de detalles principales -->
              <mat-card class="info-card" appearance="outlined">
                <mat-card-header>
                  <mat-icon mat-card-avatar>description</mat-icon>
                  <mat-card-title>Detalles del Evento</mat-card-title>
                </mat-card-header>
                <mat-card-content
                  class="detalles-evento-content"
                  [class.con-imagenes]="imagenesEntidad.length > 0"
                >
                  <div class="detalles-evento-info">
                    <div class="info-item">
                      <mat-icon class="info-icon">info</mat-icon>
                      <span class="info-text">
                        {{ getMensaje() }}
                      </span>
                    </div>

                    <!-- Sirena  -->
                    @if (data.tipoEvento === 'Evento Sirena') {
                      <div class="info-item">
                        <mat-icon class="info-icon">phone</mat-icon>
                        <span class="info-text">
                          {{ data.valores?.telefono }}
                        </span>
                      </div>

                      <div class="info-item">
                        <mat-icon class="info-icon">volume_up</mat-icon>
                        <span class="info-text">
                          {{ data.valores?.chipId }}
                        </span>
                      </div>

                      @if (data.valores.direccion) {
                        <div class="info-item">
                          <mat-icon class="info-icon">location_pin</mat-icon>
                          <span class="info-text">
                            {{ data.valores.direccion }}
                          </span>
                        </div>
                      }
                    }
                    <!-- Activo -->
                    @if (data.activo) {
                      <div class="info-item">
                        <mat-icon class="info-icon">devices</mat-icon>
                        <span class="info-text">
                          {{ data.activo.identificacion }}
                        </span>
                      </div>
                    }

                    <!-- Luminaria -->
                    @if (data.luminaria) {
                      <div class="info-item">
                        <mat-icon class="info-icon">lightbulb</mat-icon>
                        <span class="info-text">
                          {{ data.luminaria.identificacion }}
                        </span>
                      </div>
                    }

                    <!-- Tracker -->
                    @if (data.tracker) {
                      <div class="info-item">
                        <mat-icon class="info-icon">gps_fixed</mat-icon>
                        <span class="info-text">
                          {{ data.tracker.nombre }}
                        </span>
                      </div>
                    }

                    <!-- Gateway -->
                    @if (data.gateway) {
                      <div class="info-item">
                        <mat-icon class="info-icon">podcasts</mat-icon>
                        <span class="info-text">
                          {{ data.gateway.nombre }}
                        </span>
                      </div>
                    }

                    <!-- Vehiculo -->
                    @if (data.activo?.vehiculo) {
                      <div class="info-item">
                        <mat-icon class="info-icon">directions_car</mat-icon>
                        <span class="info-text">
                          {{ data.activo?.vehiculo?.tipo }} -
                          {{ data.activo?.vehiculo?.patente }}
                        </span>
                      </div>

                      @if (direccion) {
                        <div class="info-item">
                          <mat-icon class="info-icon">place</mat-icon>
                          <span class="info-text">{{ direccion }}</span>
                        </div>
                      } @else {
                        <div class="info-item muted">
                          <mat-icon class="info-icon">location_off</mat-icon>
                          <span class="info-text">
                            Sin dirección disponible
                          </span>
                        </div>
                      }

                      @if (ultimoReporte?.valores) {
                        @if (ultimoReporte.tipoReporte === 'Tracker 4G') {
                          @let valores = ultimoReporte?.valores;
                          @if (valores?.velocidad || valores?.velocidad === 0) {
                            <div class="info-item">
                              <mat-icon class="info-icon">speed</mat-icon>
                              <span class="info-text">
                                {{ valores.velocidad }} km/h
                              </span>
                            </div>
                          } @else {
                            <div class="info-item muted">
                              <mat-icon class="info-icon">speed</mat-icon>
                              <span class="info-text">Sin velocidad</span>
                            </div>
                          }
                        }
                      } @else {
                        <div class="info-item muted">
                          <mat-icon class="info-icon">report_off</mat-icon>
                          <span class="info-text">Sin último reporte</span>
                        </div>
                      }
                    }

                    <!-- Alarma -->
                    @if (data.alarma) {
                      @if (
                        comunicadoresResueltos.length || data.alarma?.modelo
                      ) {
                        <div class="info-item">
                          <mat-icon class="info-icon">router</mat-icon>
                          <span class="info-text">
                            @for (
                              c of comunicadoresResueltos;
                              track c.idComunicador
                            ) {
                              {{ c.modelo?.marca }} {{ c.modelo?.modelo }}
                            }
                            -
                            {{ data.alarma?.modelo?.marca }}
                            {{ data.alarma?.modelo?.modelo }}
                          </span>
                        </div>
                      }

                      @if (data.alarma?.domicilio) {
                        <div class="info-item">
                          <mat-icon class="info-icon">place</mat-icon>
                          <span class="info-text">
                            {{
                              data.alarma?.domicilio.identificacion ||
                                data.alarma?.domicilio.direccion
                            }}
                          </span>
                          @if (data.alarma?.domicilio.fotos?.length) {
                            <button
                              irxBotonIcono
                              tono="primario"
                              (click)="verFotos(); $event.stopPropagation()"
                              tooltip="Ver fotos"
                              class="inline-action-btn"
                            >
                              <mat-icon>photo_library</mat-icon>
                            </button>
                          }
                        </div>
                      }
                    }
                  </div>

                  <!-- Imágenes de la entidad (30% derecha, si las tuviera) -->
                  @if (imagenesEntidad.length > 0) {
                    <div class="detalles-evento-imagenes">
                      <app-carrusel
                        [imagenes]="imagenesEntidad"
                        [inlineControls]="false"
                      ></app-carrusel>
                    </div>
                  }
                </mat-card-content>
              </mat-card>

              <!-- Card de acciones rápidas -->
              <mat-card class="info-card actions-card" appearance="outlined">
                <mat-card-header>
                  <mat-icon mat-card-avatar>touch_app</mat-icon>
                  <mat-card-title>Acciones Rápidas</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="quick-actions">
                    <!-- Boton de Detalles -->
                    <button
                      irxBoton="tonal"
                      bloque
                      (click)="verDetallesEntidad(); $event.stopPropagation()"
                      class="quick-action-btn"
                    >
                      <mat-icon>open_in_new</mat-icon>
                      Detalles
                    </button>

                    <!-- Boton de Ver en mapa (solo vehículos) -->
                    @if (esEventoVehiculo()) {
                      <button
                        irxBoton="tonal"
                        bloque
                        (click)="verEnMapa(); $event.stopPropagation()"
                        class="quick-action-btn"
                      >
                        <mat-icon>directions_car</mat-icon>
                        Ver en mapa
                      </button>
                    }

                    <!-- Boton de control horario -->
                    @if (tieneControlHorario()) {
                      <button
                        irxBoton="tonal"
                        bloque
                        (click)="verControlHorario(); $event.stopPropagation()"
                        class="quick-action-btn"
                      >
                        <mat-icon>schedule</mat-icon>
                        Control Horario
                      </button>
                    }

                    <!-- Botones de servicio técnico -->
                    <button
                      irxBoton="tonal"
                      bloque
                      (click)="verServicioTecnico(); $event.stopPropagation()"
                      class="quick-action-btn"
                    >
                      <mat-icon>event</mat-icon>
                      Servicio Técnico
                    </button>

                    <!-- Boton Histórico -->
                    <button
                      irxBoton="tonal"
                      bloque
                      (click)="verHistoricoEventos(); $event.stopPropagation()"
                      class="quick-action-btn"
                    >
                      <mat-icon>description</mat-icon>
                      Histórico
                    </button>

                    <!-- Boton Ubicacion -->
                    @if (tieneGeojson()) {
                      <button
                        irxBoton="tonal"
                        bloque
                        (click)="verUbicacion(); $event.stopPropagation()"
                        class="quick-action-btn"
                      >
                        <mat-icon>map</mat-icon>
                        Ubicación
                      </button>
                    }

                    <!-- Boton Camaras -->
                    @if (tieneCamaras()) {
                      <button
                        irxBoton="tonal"
                        bloque
                        (click)="verCamaras(); $event.stopPropagation()"
                        class="quick-action-btn"
                      >
                        <mat-icon>videocam</mat-icon>
                        Cámaras
                      </button>
                    }

                    <!-- Emergencia AVL (vehículos/trackers, con credenciales
                         cargadas en el cliente) -->
                    @if (puedeDeclararEmergenciaAvl()) {
                      <button
                        irxBoton="peligro"
                        bloque
                        (click)="
                          declararEmergenciaAvl(); $event.stopPropagation()
                        "
                        class="quick-action-btn"
                      >
                        <mat-icon>emergency_share</mat-icon>
                        Emergencia AVL
                      </button>
                    }

                    <!-- Boton Vecino (solo para sirenas) -->
                    @if (data.tipoEvento === 'Evento Sirena') {
                      <button
                        irxBoton="tonal"
                        bloque
                        (click)="verVecino(); $event.stopPropagation()"
                        class="quick-action-btn"
                      >
                        <mat-icon>person</mat-icon>
                        Vecino
                      </button>
                    }
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>

          <mat-divider class="section-divider"></mat-divider>

          <!-- Notas, contactos, eventos y tratamientos -->
          <div class="data-grid">
            <!-- Columna izquierda: Notas y Eventos -->
            <div class="data-column">
              <!-- Eventos a tratar -->
              <mat-card class="data-card" appearance="outlined">
                <mat-card-header class="data-card-header">
                  <mat-icon mat-card-avatar>report</mat-icon>
                  <mat-card-title>Eventos a Tratar</mat-card-title>
                  <mat-card-subtitle>
                    {{ idsEventosDispositivoSeleccionados?.length || 0 }} de
                    {{ eventosDispositivo.length }} seleccionado(s)
                  </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <div class="select-all-container">
                    <mat-checkbox
                      color="primary"
                      [checked]="
                        idsEventosDispositivoSeleccionados?.length ===
                        eventosDispositivo.length
                      "
                      (change)="marcarTodos($event.checked)"
                    >
                      <span style="padding-left: 16px">Seleccionar todos</span>
                    </mat-checkbox>
                  </div>
                  <div class="scrollable-content eventos-content">
                    @for (evento of eventosDispositivo; track evento._id) {
                      <div class="list-item evento-item" [class.even]="$even">
                        <div class="list-item-header">
                          <div class="evento-title-container">
                            <mat-checkbox
                              color="primary"
                              [checked]="marcado(evento)"
                              (change)="cambiarMarcado($event.checked, evento)"
                              class="evento-checkbox"
                            ></mat-checkbox>
                            <div class="evento-info">
                              <span class="evento-titulo">
                                {{ evento.valores.titulo }}
                              </span>
                              <span class="evento-mensaje">
                                {{ evento.valores.mensaje }}
                              </span>
                            </div>
                          </div>
                          <div class="evento-actions">
                            <span class="evento-timestamp">
                              {{
                                evento.fechaCreacion | date: 'dd/MM/yyyy HH:mm'
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                      @if (!$last) {
                        <mat-divider class="item-divider"></mat-divider>
                      }
                    }
                  </div>
                </mat-card-content>
              </mat-card>

              <!-- Últimos eventos -->
              <mat-card class="data-card data-card-fill" appearance="outlined">
                <mat-card-header class="data-card-header">
                  <mat-icon mat-card-avatar>history</mat-icon>
                  <mat-card-title>Últimos Eventos</mat-card-title>
                  <mat-card-subtitle>
                    {{ ultimosEventos?.length || 0 }} evento(s)
                  </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content
                  class="scrollable-content ultimos-eventos-content"
                >
                  @if (ultimosEventos?.length) {
                    @for (evento of ultimosEventos; track evento._id) {
                      <div class="list-item" [class.even]="$even">
                        <div class="list-item-header">
                          <div class="evento-title-container">
                            <mat-icon class="list-item-icon">
                              event_note
                            </mat-icon>
                            <div class="evento-info">
                              <span class="evento-titulo">
                                {{ evento.valores.titulo }}
                              </span>
                              <span class="evento-mensaje">
                                {{ evento.valores.mensaje }}
                              </span>
                            </div>
                          </div>
                          <span class="evento-timestamp">
                            {{
                              evento.fechaCreacion | date: 'dd/MM/yyyy HH:mm'
                            }}
                          </span>
                        </div>
                      </div>
                      @if (!$last) {
                        <mat-divider class="item-divider"></mat-divider>
                      }
                    }
                  } @else {
                    <div class="empty-state">
                      <mat-icon>inbox</mat-icon>
                      <p>No hay eventos recientes</p>
                    </div>
                  }
                </mat-card-content>
              </mat-card>
            </div>

            <!-- Columna derecha: Contactos y Tratamientos -->
            <div class="data-column">
              <!-- Contactos -->
              <mat-card class="data-card" appearance="outlined">
                <mat-card-header class="data-card-header">
                  <mat-icon mat-card-avatar>contacts</mat-icon>
                  <mat-card-title>Contactos</mat-card-title>
                  <mat-card-subtitle>
                    {{ contactos.length }} contacto(s)
                  </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content class="scrollable-content contactos-content">
                  @if (contactos.length) {
                    @for (contacto of contactos; track contacto._id) {
                      @if (contacto.informacion?.telefono) {
                        <div
                          class="list-item contacto-item"
                          [class.even]="$even"
                        >
                          <div class="contacto-header">
                            <mat-icon class="list-item-icon">person</mat-icon>
                            <div class="contacto-info">
                              <span class="contacto-nombre">
                                {{ contacto.informacion?.contacto }}
                              </span>
                              @if (contacto.categoriaEvento?.nombre) {
                                <mat-chip
                                  class="categoria-evento-chip"
                                  [style.background-color]="
                                    contacto.categoriaEvento?.color
                                  "
                                  [style.color]="
                                    helper.colorDeTextoSegunColor(
                                      contacto.categoriaEvento?.color
                                    )
                                  "
                                >
                                  {{ contacto.categoriaEvento?.nombre }}
                                </mat-chip>
                              }
                              @if (contacto.informacion?.particion) {
                                <mat-chip class="categoria-evento-chip">
                                  Partición
                                  {{ contacto.informacion?.particion }}
                                </mat-chip>
                              }
                              <div class="contacto-detalles">
                                <div class="contacto-detail">
                                  <mat-icon class="detail-icon">phone</mat-icon>
                                  <span>
                                    {{ contacto.informacion?.telefono }}
                                  </span>
                                </div>
                                @if (contacto.informacion?.email) {
                                  <div class="contacto-detail">
                                    <mat-icon class="detail-icon">
                                      email
                                    </mat-icon>
                                    <span>
                                      {{ contacto.informacion?.email }}
                                    </span>
                                  </div>
                                }
                              </div>
                              @if (contacto.informacion?.nota) {
                                <span class="contacto-nota">
                                  {{ contacto.informacion?.nota }}
                                </span>
                              }
                              @if (
                                contacto.informacion
                                  ?.tieneCodigoSeguridadNormal ||
                                contacto.informacion
                                  ?.tieneCodigoSeguridadEmergencia
                              ) {
                                <div class="palabras-seguridad">
                                  @if (!codigosSeguridadDe(contacto._id)) {
                                    <mat-chip class="security-chip">
                                      <mat-icon>key</mat-icon>
                                      Códigos de seguridad ocultos
                                    </mat-chip>
                                    @if (cargandoCodigosDe(contacto._id)) {
                                      <mat-spinner diameter="20"></mat-spinner>
                                    } @else {
                                      <button
                                        irxBotonIcono
                                        type="button"
                                        (click)="verCodigosSeguridad(contacto)"
                                        tooltip="Ver códigos de seguridad"
                                      >
                                        <mat-icon>visibility</mat-icon>
                                      </button>
                                    }
                                  } @else {
                                    @if (
                                      contacto.informacion
                                        ?.tieneCodigoSeguridadNormal
                                    ) {
                                      <mat-chip class="security-chip">
                                        <mat-icon>key</mat-icon>
                                        {{
                                          codigosSeguridadDe(contacto._id)
                                            ?.palabraSeguridadNormal
                                        }}
                                      </mat-chip>
                                    }
                                    @if (
                                      contacto.informacion
                                        ?.tieneCodigoSeguridadEmergencia
                                    ) {
                                      <mat-chip class="security-chip emergency">
                                        <mat-icon>warning</mat-icon>
                                        {{
                                          codigosSeguridadDe(contacto._id)
                                            ?.palabraSeguridadEmergencia
                                        }}
                                      </mat-chip>
                                    }
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                        @if (!$last) {
                          <mat-divider class="item-divider"></mat-divider>
                        }
                      }
                    }
                  } @else {
                    <div class="empty-state">
                      <mat-icon>person_off</mat-icon>
                      <p>No hay contactos disponibles</p>
                    </div>
                  }
                </mat-card-content>
              </mat-card>

              <!-- Notas -->
              <mat-card class="data-card" appearance="outlined">
                <mat-card-header class="data-card-header">
                  <mat-icon mat-card-avatar>note</mat-icon>
                  <mat-card-title>Notas</mat-card-title>
                  <mat-card-subtitle>
                    {{ notas.length }} nota(s)
                  </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content class="scrollable-content notes-content">
                  @if (notas.length) {
                    @for (nota of notas; track nota._id) {
                      <div class="list-item" [class.even]="$even">
                        <div class="list-item-content">
                          <mat-icon class="list-item-icon">note</mat-icon>
                          <span class="list-item-text">
                            {{ nota.informacion?.nota }}
                          </span>
                          @if (nota.categoriaEvento?.nombre) {
                            <mat-chip
                              class="categoria-evento-chip"
                              [style.background-color]="
                                nota.categoriaEvento?.color
                              "
                              [style.color]="
                                helper.colorDeTextoSegunColor(
                                  nota.categoriaEvento?.color
                                )
                              "
                            >
                              {{ nota.categoriaEvento?.nombre }}
                            </mat-chip>
                          }
                          @if (nota.informacion?.particion) {
                            <mat-chip class="categoria-evento-chip">
                              Partición {{ nota.informacion?.particion }}
                            </mat-chip>
                          }
                        </div>
                      </div>
                      @if (!$last) {
                        <mat-divider class="item-divider"></mat-divider>
                      }
                    }
                  } @else {
                    <div class="empty-state">
                      <mat-icon>inbox</mat-icon>
                      <p>No hay notas disponibles</p>
                    </div>
                  }
                </mat-card-content>
              </mat-card>

              <!-- Atendiendo: solo con más de un operador (uno solo es ruido) -->
              @if (usuariosAtendiendo.length > 1) {
                <mat-card class="data-card" appearance="outlined">
                  <mat-card-header class="data-card-header">
                    <mat-icon mat-card-avatar>headset_mic</mat-icon>
                    <mat-card-title>Atendiendo</mat-card-title>
                    <mat-card-subtitle>
                      {{ usuariosAtendiendo.length }} operador(es)
                    </mat-card-subtitle>
                  </mat-card-header>
                  <mat-card-content>
                    @for (usuario of usuariosAtendiendo; track usuario._id) {
                      <div class="list-item atendiendo-item">
                        <mat-icon class="list-item-icon">person</mat-icon>
                        <span class="list-item-text">
                          {{ nombreUsuario(usuario) }}
                          @if (esUsuarioActual(usuario)) {
                            <strong>(vos)</strong>
                          }
                        </span>
                      </div>
                      @if (!$last) {
                        <mat-divider class="item-divider"></mat-divider>
                      }
                    }
                  </mat-card-content>
                </mat-card>
              }

              <!-- Tratamientos -->
              <mat-card class="data-card" appearance="outlined">
                <mat-card-header class="data-card-header">
                  <mat-icon mat-card-avatar>assignment</mat-icon>
                  <mat-card-title>Tratamientos</mat-card-title>
                  <mat-card-subtitle>
                    {{ tratamientosEvento?.length || 0 }} tratamiento(s)
                  </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content
                  class="scrollable-content tratamientos-content"
                >
                  @if (tratamientosEvento?.length) {
                    @for (
                      tratamiento of tratamientosEvento;
                      track tratamiento._id
                    ) {
                      <div
                        class="list-item tratamiento-item"
                        [class.even]="$even"
                        [class.propio]="esTratamientoPropio(tratamiento)"
                      >
                        <div class="tratamiento-header">
                          <mat-icon class="list-item-icon">
                            assignment_turned_in
                          </mat-icon>
                          <div class="tratamiento-info">
                            <div class="tratamiento-status-row">
                              <mat-chip
                                class="estado-chip"
                                [class]="
                                  'estado-' +
                                  (
                                    tratamiento.estado ??
                                    tratamiento.estadoTecnico ??
                                    ''
                                  )
                                    .toLowerCase()
                                    .replace(' ', '-')
                                "
                              >
                                {{
                                  tratamiento.estado ??
                                    tratamiento.estadoTecnico
                                }}
                              </mat-chip>
                              <span class="tratamiento-timestamp">
                                {{
                                  tratamiento.fechaCreacion
                                    | date: 'dd/MM/yyyy HH:mm'
                                }}
                              </span>
                            </div>
                            <span class="tratamiento-usuario">
                              <mat-icon class="user-icon">person</mat-icon>
                              {{ tratamiento.usuario?.usuario || 'Sistema' }}
                            </span>
                            @if (tratamiento.nota) {
                              <div class="tratamiento-nota">
                                <mat-icon class="note-icon">comment</mat-icon>
                                <span>{{ tratamiento.nota }}</span>
                              </div>
                            }
                            @if (tratamiento.notaInterna) {
                              <div class="tratamiento-nota interna">
                                <mat-icon class="note-icon">lock</mat-icon>
                                <span>
                                  <strong>Interna:</strong>
                                  {{ tratamiento.notaInterna }}
                                </span>
                              </div>
                            }
                            @if (tratamiento.imagenes?.length) {
                              <app-carrusel
                                [imagenes]="tratamiento.imagenes"
                                [enableFullscreen]="true"
                              ></app-carrusel>
                            }
                          </div>
                        </div>
                      </div>
                      @if (!$last) {
                        <mat-divider class="item-divider"></mat-divider>
                      }
                    }
                  } @else {
                    <div class="empty-state">
                      <mat-icon>assignment_late</mat-icon>
                      <p>No hay tratamientos registrados</p>
                    </div>
                  }
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </mat-card-content>

        <!-- Acciones -->
        <mat-dialog-actions class="tratamiento-actions">
          @if (
            !tratando &&
            estadoActual !== 'Finalizada' &&
            estadoActual !== 'En Espera'
          ) {
            <!-- Estado: Sin tratar / Sin Tratamiento / Pendiente -->
            <div class="actions-container">
              @if (bloqueadoPorOtro) {
                <div class="atencion-bloqueada">
                  <mat-icon>lock</mat-icon>
                  <span>Siendo atendido por {{ nombresAtendiendo }}</span>
                </div>
              } @else {
                <app-button
                  matType="mat-fab extended"
                  color="primary"
                  [text]="
                    eventosDispositivo?.length
                      ? 'Iniciar tratamiento'
                      : 'No hay eventos'
                  "
                  icon="monitor_heart"
                  [disabled]="loading || !eventosDispositivo?.length"
                  (click)="
                    !(loading || !eventosDispositivo?.length) ? tratar() : null;
                    $event.stopPropagation()
                  "
                ></app-button>
              }
            </div>
          }

          @if (
            tratando &&
            estadoActual !== 'Finalizada' &&
            estadoActual !== 'En Espera'
          ) {
            <!-- Estado: En tratamiento / En Atención -->
            <div class="actions-container tratando">
              <div class="actions-group primary-actions">
                <!-- Agregar nota -->
                <app-button
                  matType="mat-fab extended"
                  color="primary"
                  (click)="agregarNota(); $event.stopPropagation()"
                  text="Agregar nota"
                  icon="add_comment"
                ></app-button>
                <!-- Liberar -->
                <app-button
                  matType="mat-fab extended"
                  color="primary"
                  text="Liberar"
                  icon="lock_open"
                  (click)="liberar(); $event.stopPropagation()"
                ></app-button>
                <!-- Enviar móvil -->
                @if (tieneEnvioMovil()) {
                  <app-button
                    matType="mat-fab extended"
                    color="primary"
                    text="Enviar móvil"
                    icon="local_shipping"
                    (click)="enviarMovil(); $event.stopPropagation()"
                  ></app-button>
                }
              </div>

              <div class="actions-group secondary-actions">
                <!-- Poner en espera -->
                <app-button
                  matType="mat-fab extended"
                  color="warn"
                  text="Poner en espera"
                  icon="pause"
                  (click)="espera(); $event.stopPropagation()"
                ></app-button>
                <!-- Finalizar -->
                <app-button
                  matType="mat-fab extended"
                  color="primary"
                  text="Finalizar tratamiento"
                  icon="task_alt"
                  (click)="finalizar(); $event.stopPropagation()"
                ></app-button>
              </div>
            </div>
          }

          @if (estadoActual === 'Finalizada') {
            <!-- Estado: Finalizado -->
            <div class="actions-container estado-final">
              <mat-icon class="estado-icon">check_circle</mat-icon>
              <h3 class="estado-mensaje">Evento Finalizado</h3>
            </div>
          }

          @if (estadoActual === 'En Espera') {
            <!-- Estado: En espera -->
            <div class="actions-container estado-espera">
              <div class="estado-info">
                <mat-icon class="estado-icon">schedule</mat-icon>
                <h3 class="estado-mensaje">Evento en Espera</h3>
              </div>
              <app-button
                matType="mat-fab extended"
                color="primary"
                (click)="tratar(); $event.stopPropagation()"
                text="Quitar de espera"
                icon="play_arrow"
              ></app-button>
            </div>
          }
        </mat-dialog-actions>
      } @else {
        <!-- Vista de eventos técnicos -->
        <mat-card-content class="tratamiento-content">
          <!-- Información del Servicio Técnico -->
          <div class="evento-info-section">
            <div class="info-cards-container">
              <!-- Card de detalles principales -->
              <mat-card class="info-card" appearance="outlined">
                <mat-card-header>
                  <mat-icon mat-card-avatar>description</mat-icon>
                  <mat-card-title>Detalles del Servicio Técnico</mat-card-title>
                  @if (esEventoTecnico() && getValoresTecnicos()?.prioridad) {
                    <mat-card-subtitle>
                      <mat-icon
                        class="prioridad-icon"
                        [style.color]="
                          getValoresTecnicos()?.prioridad === 'Urgente'
                            ? '#f44336'
                            : getValoresTecnicos()?.prioridad === 'Alta'
                              ? '#ff9800'
                              : '#4caf50'
                        "
                      >
                        {{
                          getValoresTecnicos()?.prioridad === 'Urgente'
                            ? 'priority_high'
                            : 'low_priority'
                        }}
                      </mat-icon>
                      <span
                        [style.color]="
                          getValoresTecnicos()?.prioridad === 'Urgente'
                            ? '#f44336'
                            : getValoresTecnicos()?.prioridad === 'Alta'
                              ? '#ff9800'
                              : '#4caf50'
                        "
                      >
                        Prioridad: {{ getValoresTecnicos()?.prioridad }}
                      </span>
                    </mat-card-subtitle>
                  }
                </mat-card-header>
                <mat-card-content>
                  <div class="info-item">
                    <mat-icon class="info-icon">confirmation_number</mat-icon>
                    <span class="info-text">
                      {{ getValoresTecnicos()?.numeroIncidente }}
                    </span>
                  </div>

                  <div class="info-item">
                    <mat-icon class="info-icon">info</mat-icon>
                    <span class="info-text">
                      {{ getMensaje() }}
                    </span>
                  </div>

                  <div class="info-item">
                    <mat-icon class="info-icon">insert_invitation</mat-icon>
                    <span class="info-text">
                      {{ this.data.fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}
                    </span>
                  </div>

                  <!-- Sirena  -->
                  @if (data.tipoEvento === 'Evento Técnico Sirena') {
                    <!-- <div class="info-item">A Completar</div> -->
                  }
                  <!-- Activo -->
                  @if (data.activo) {
                    <div class="info-item">
                      <mat-icon class="info-icon">devices</mat-icon>
                      <span class="info-text">
                        {{ data.activo.identificacion }}
                      </span>
                    </div>
                  }

                  <!-- Luminaria -->
                  @if (data.luminaria) {
                    <div class="info-item">
                      <mat-icon class="info-icon">lightbulb</mat-icon>
                      <span class="info-text">
                        {{ data.luminaria.identificacion }}
                      </span>
                    </div>
                  }

                  <!-- Tracker -->
                  @if (data.tracker) {
                    <div class="info-item">
                      <mat-icon class="info-icon">gps_fixed</mat-icon>
                      <span class="info-text">
                        {{ data.tracker.identificacion }}
                      </span>
                    </div>
                  }

                  <!-- Gateway -->
                  @if (data.gateway) {
                    <div class="info-item">
                      <mat-icon class="info-icon">podcasts</mat-icon>
                      <span class="info-text">
                        {{ data.gateway.nombre }}
                      </span>
                    </div>
                  }

                  <!-- Vehiculo -->
                  @if (data.activo?.vehiculo) {
                    <div class="info-item">
                      <mat-icon class="info-icon">directions_car</mat-icon>
                      <span class="info-text">
                        {{ data.activo?.vehiculo?.tipo }} -
                        {{ data.activo?.vehiculo?.patente }}
                      </span>
                    </div>

                    @if (direccion) {
                      <div class="info-item">
                        <mat-icon class="info-icon">place</mat-icon>
                        <span class="info-text">{{ direccion }}</span>
                      </div>
                    } @else {
                      <div class="info-item muted">
                        <mat-icon class="info-icon">location_off</mat-icon>
                        <span class="info-text">Sin dirección disponible</span>
                      </div>
                    }
                  }

                  <!-- Alarma -->
                  @if (data.alarma) {
                    @if (comunicadoresResueltos.length || data.alarma?.modelo) {
                      <div class="info-item">
                        <mat-icon class="info-icon">router</mat-icon>
                        <span class="info-text">
                          @for (
                            c of comunicadoresResueltos;
                            track c.idComunicador
                          ) {
                            {{ c.modelo?.marca }} {{ c.modelo?.modelo }}
                          }
                          -
                          {{ data.alarma?.modelo?.marca }}
                          {{ data.alarma?.modelo?.modelo }}
                        </span>
                      </div>
                    }

                    @if (data.alarma?.domicilio) {
                      <div class="info-item">
                        <mat-icon class="info-icon">place</mat-icon>
                        <span class="info-text">
                          {{ data.alarma?.domicilio.identificacion }}
                        </span>
                        @if (data.alarma?.domicilio.fotos?.length) {
                          <button
                            irxBotonIcono
                            tono="primario"
                            (click)="verFotos(); $event.stopPropagation()"
                            tooltip="Ver fotos"
                            class="inline-action-btn"
                          >
                            <mat-icon>photo_library</mat-icon>
                          </button>
                        }
                      </div>
                    }
                  }
                </mat-card-content>
              </mat-card>

              <!-- Card de acciones rápidas -->
              <mat-card class="info-card actions-card" appearance="outlined">
                <mat-card-header>
                  <mat-icon mat-card-avatar>touch_app</mat-icon>
                  <mat-card-title>Acciones Rápidas</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="quick-actions">
                    <button
                      irxBoton="tonal"
                      bloque
                      (click)="verDetallesEntidad(); $event.stopPropagation()"
                      class="quick-action-btn"
                    >
                      <mat-icon>open_in_new</mat-icon>
                      Detalles
                    </button>

                    <!-- Boton de Ver en mapa (solo vehículos) -->
                    @if (esEventoVehiculo()) {
                      <button
                        irxBoton="tonal"
                        bloque
                        (click)="verEnMapa(); $event.stopPropagation()"
                        class="quick-action-btn"
                      >
                        <mat-icon>directions_car</mat-icon>
                        Ver en mapa
                      </button>
                    }

                    @if (tieneControlHorario()) {
                      <button
                        irxBoton="tonal"
                        bloque
                        (click)="verControlHorario(); $event.stopPropagation()"
                        class="quick-action-btn"
                      >
                        <mat-icon>schedule</mat-icon>
                        Control Horario
                      </button>
                    }

                    <button
                      irxBoton="principal"
                      bloque
                      (click)="asignarTecnico(); $event.stopPropagation()"
                      class="quick-action-btn"
                    >
                      <mat-icon>person_add</mat-icon>
                      Asignar técnico
                    </button>

                    <!-- Boton Certificados (solo trackers y vehículos) -->
                    @if (esEventoVehiculoActivo()) {
                      <span
                        [tooltip]="
                          !ultimoCertificado ? 'Sin certificado realizado' : ''
                        "
                      >
                        <button
                          irxBoton="tonal"
                          bloque
                          [disabled]="!ultimoCertificado"
                          (click)="verCertificado(); $event.stopPropagation()"
                          class="quick-action-btn"
                        >
                          <mat-icon>verified</mat-icon>
                          Certificados
                        </button>
                      </span>
                    }

                    <button
                      irxBoton="tonal"
                      bloque
                      (click)="verHistoricoEventos(); $event.stopPropagation()"
                      class="quick-action-btn"
                    >
                      <mat-icon>description</mat-icon>
                      Histórico
                    </button>

                    @if (tieneGeojson()) {
                      <button
                        irxBoton="tonal"
                        bloque
                        (click)="verUbicacion(); $event.stopPropagation()"
                        class="quick-action-btn"
                      >
                        <mat-icon>map</mat-icon>
                        Ubicación
                      </button>
                    }
                  </div>
                </mat-card-content>
              </mat-card>

              <!-- Notas y tratamientos -->
              <div class="data-grid data-grid-full">
                <!-- Columna derecha: Contactos y Tratamientos -->

                <!-- Técnico Asignado (solo eventos técnicos) -->
                @if (esEventoTecnico() && data.detallesTecnicos?.tecnico) {
                  <mat-card class="data-card" appearance="outlined">
                    <mat-card-header class="data-card-header">
                      @if (
                        data.detallesTecnicos.tecnico.datosPersonales?.foto
                      ) {
                        <img
                          mat-card-avatar
                          [src]="
                            data.detallesTecnicos.tecnico.datosPersonales.foto
                          "
                          [alt]="
                            data.detallesTecnicos.tecnico.datosPersonales
                              ?.nombre || data.detallesTecnicos.tecnico.usuario
                          "
                          class="avatar-image"
                        />
                      } @else {
                        <mat-icon mat-card-avatar>engineering</mat-icon>
                      }
                      <mat-card-title>Técnico Asignado</mat-card-title>
                    </mat-card-header>
                    <mat-card-content class="scrollable-content">
                      <div class="list-item">
                        <div class="list-item-content">
                          <mat-icon class="list-item-icon">person</mat-icon>
                          <span class="list-item-text">
                            {{
                              data.detallesTecnicos.tecnico.datosPersonales
                                ?.nombre ||
                                data.detallesTecnicos.tecnico.usuario
                            }}
                          </span>
                        </div>
                      </div>
                      @if (
                        data.detallesTecnicos.tecnico.datosPersonales?.telefono
                      ) {
                        <div class="list-item">
                          <div class="list-item-content">
                            <mat-icon class="list-item-icon">phone</mat-icon>
                            <span class="list-item-text">
                              {{
                                data.detallesTecnicos.tecnico.datosPersonales
                                  .telefono
                              }}
                            </span>
                          </div>
                        </div>
                      }
                      @if (
                        data.detallesTecnicos.tecnico.datosPersonales?.email
                      ) {
                        <div class="list-item">
                          <div class="list-item-content">
                            <mat-icon class="list-item-icon">email</mat-icon>
                            <span class="list-item-text">
                              {{
                                data.detallesTecnicos.tecnico.datosPersonales
                                  .email
                              }}
                            </span>
                          </div>
                        </div>
                      }
                    </mat-card-content>
                  </mat-card>
                }

                <!-- Solicitante (solo eventos técnicos) -->
                @if (esEventoTecnico() && getValoresTecnicos()?.solicitante) {
                  <mat-card class="data-card" appearance="outlined">
                    <mat-card-header class="data-card-header">
                      <mat-icon mat-card-avatar>person</mat-icon>
                      <mat-card-title>Solicitante</mat-card-title>
                    </mat-card-header>
                    <mat-card-content class="scrollable-content">
                      @if (getValoresTecnicos()?.solicitante?.nombre) {
                        <div class="list-item">
                          <div class="list-item-content">
                            <mat-icon class="list-item-icon">badge</mat-icon>
                            <span class="list-item-text">
                              {{ getValoresTecnicos()?.solicitante?.nombre }}
                            </span>
                          </div>
                        </div>
                      }

                      @if (getValoresTecnicos()?.solicitante?.telefono) {
                        <div class="list-item">
                          <div class="list-item-content">
                            <mat-icon class="list-item-icon">phone</mat-icon>
                            <span class="list-item-text">
                              {{ getValoresTecnicos()?.solicitante?.telefono }}
                            </span>
                          </div>
                        </div>
                      }

                      @if (getValoresTecnicos()?.solicitante?.email) {
                        <div class="list-item">
                          <div class="list-item-content">
                            <mat-icon class="list-item-icon">email</mat-icon>
                            <span class="list-item-text">
                              {{ getValoresTecnicos()?.solicitante?.email }}
                            </span>
                          </div>
                        </div>
                      }
                    </mat-card-content>
                  </mat-card>
                }

                <!-- Notas -->
                <mat-card class="data-card" appearance="outlined">
                  <mat-card-header class="data-card-header">
                    <mat-icon mat-card-avatar>note</mat-icon>
                    <mat-card-title>Notas</mat-card-title>
                    <mat-card-subtitle>
                      {{ notas.length }} nota(s)
                    </mat-card-subtitle>
                  </mat-card-header>
                  <mat-card-content class="scrollable-content notes-content">
                    @if (notas.length) {
                      @for (nota of notas; track nota._id) {
                        <div class="list-item" [class.even]="$even">
                          <div class="list-item-content">
                            <mat-icon class="list-item-icon">note</mat-icon>
                            <span class="list-item-text">
                              {{ nota.informacion?.nota }}
                            </span>
                            @if (nota.categoriaEvento?.nombre) {
                              <mat-chip
                                class="categoria-evento-chip"
                                [style.background-color]="
                                  nota.categoriaEvento?.color
                                "
                                [style.color]="
                                  helper.colorDeTextoSegunColor(
                                    nota.categoriaEvento?.color
                                  )
                                "
                              >
                                {{ nota.categoriaEvento?.nombre }}
                              </mat-chip>
                            }
                            @if (nota.informacion?.particion) {
                              <mat-chip class="categoria-evento-chip">
                                Partición {{ nota.informacion?.particion }}
                              </mat-chip>
                            }
                          </div>
                        </div>
                        @if (!$last) {
                          <mat-divider class="item-divider"></mat-divider>
                        }
                      }
                    } @else {
                      <div class="empty-state">
                        <mat-icon>inbox</mat-icon>
                        <p>No hay notas disponibles</p>
                      </div>
                    }
                  </mat-card-content>
                </mat-card>

                <!-- Tratamientos -->
                <mat-card class="data-card" appearance="outlined">
                  <mat-card-header class="data-card-header">
                    <mat-icon mat-card-avatar>assignment</mat-icon>
                    <mat-card-title>Tratamientos</mat-card-title>
                    <mat-card-subtitle>
                      {{ tratamientosEvento?.length || 0 }} tratamiento(s)
                    </mat-card-subtitle>
                  </mat-card-header>
                  <mat-card-content
                    class="scrollable-content tratamientos-content"
                  >
                    @if (tratamientosEvento?.length) {
                      @for (
                        tratamiento of tratamientosEvento;
                        track tratamiento._id
                      ) {
                        <div
                          class="list-item tratamiento-item"
                          [class.even]="$even"
                        >
                          <div class="tratamiento-header">
                            <mat-icon class="list-item-icon">
                              assignment_turned_in
                            </mat-icon>
                            <div class="tratamiento-info">
                              <div class="tratamiento-status-row">
                                <mat-chip
                                  class="estado-chip"
                                  [class]="
                                    'estado-' +
                                    (
                                      tratamiento.estadoTecnico ??
                                      tratamiento.estado ??
                                      ''
                                    )
                                      .toLowerCase()
                                      .replace(' ', '-')
                                  "
                                >
                                  {{
                                    tratamiento.estadoTecnico ??
                                      tratamiento.estado
                                  }}
                                </mat-chip>
                                <span class="tratamiento-timestamp">
                                  {{
                                    tratamiento.fechaCreacion
                                      | date: 'dd/MM/yyyy HH:mm'
                                  }}
                                </span>
                              </div>
                              <span class="tratamiento-usuario">
                                <mat-icon class="user-icon">person</mat-icon>
                                {{ tratamiento.usuario?.usuario || 'Sistema' }}
                              </span>
                              @if (tratamiento.nota) {
                                <div class="tratamiento-nota">
                                  <mat-icon class="note-icon">comment</mat-icon>
                                  <span>{{ tratamiento.nota }}</span>
                                </div>
                              }
                              @if (tratamiento.notaInterna) {
                                <div class="tratamiento-nota interna">
                                  <mat-icon class="note-icon">lock</mat-icon>
                                  <span>
                                    <strong>Interna:</strong>
                                    {{ tratamiento.notaInterna }}
                                  </span>
                                </div>
                              }
                              @if (tratamiento.imagenes?.length) {
                                <app-carrusel
                                  [imagenes]="tratamiento.imagenes"
                                  [enableFullscreen]="true"
                                ></app-carrusel>
                              }
                            </div>
                          </div>
                        </div>
                        @if (!$last) {
                          <mat-divider class="item-divider"></mat-divider>
                        }
                      }
                    } @else {
                      <div class="empty-state">
                        <mat-icon>assignment_late</mat-icon>
                        <p>No hay tratamientos registrados</p>
                      </div>
                    }
                  </mat-card-content>
                </mat-card>

                <!-- Materiales (registrados por el técnico desde la app) -->
                <mat-card class="data-card" appearance="outlined">
                  <mat-card-header class="data-card-header">
                    <mat-icon mat-card-avatar>inventory_2</mat-icon>
                    <mat-card-title>Materiales</mat-card-title>
                    <mat-card-subtitle>
                      {{ materiales.length }} material(es)
                    </mat-card-subtitle>
                  </mat-card-header>
                  <mat-card-content
                    class="scrollable-content tratamientos-content"
                  >
                    @if (materiales.length) {
                      @for (material of materiales; track material._id) {
                        <div
                          class="list-item tratamiento-item"
                          [class.even]="$even"
                        >
                          <div class="tratamiento-header">
                            <mat-icon class="list-item-icon">
                              inventory_2
                            </mat-icon>
                            <div class="tratamiento-info">
                              <div class="tratamiento-status-row">
                                <mat-chip
                                  class="estado-chip"
                                  [class]="'tipo-' + material.tipo"
                                >
                                  {{
                                    material.tipo === 'pedido'
                                      ? 'Pedido'
                                      : 'Usado'
                                  }}
                                </mat-chip>
                                @if (material.estado) {
                                  <mat-chip
                                    class="estado-chip"
                                    [class]="
                                      'estado-' + material.estado.toLowerCase()
                                    "
                                  >
                                    {{ material.estado }}
                                  </mat-chip>
                                }
                                <span class="tratamiento-timestamp">
                                  {{
                                    material.fechaCreacion
                                      | date: 'dd/MM/yyyy HH:mm'
                                  }}
                                </span>
                              </div>
                              <span class="tratamiento-usuario">
                                <mat-icon class="user-icon">person</mat-icon>
                                {{ material.usuario?.usuario || 'Sistema' }}
                              </span>
                              <div class="tratamiento-nota">
                                <mat-icon class="note-icon">
                                  description
                                </mat-icon>
                                <span>
                                  {{ material.descripcion }}
                                  @if (material.cantidad) {
                                    <strong>x{{ material.cantidad }}</strong>
                                  }
                                </span>
                              </div>
                              @if (material.imagenes?.length) {
                                <app-carrusel
                                  [imagenes]="material.imagenes"
                                  [enableFullscreen]="true"
                                ></app-carrusel>
                              }
                            </div>
                          </div>
                        </div>
                        @if (!$last) {
                          <mat-divider class="item-divider"></mat-divider>
                        }
                      }
                    } @else {
                      <div class="empty-state">
                        <mat-icon>inventory_2</mat-icon>
                        <p>No hay materiales registrados</p>
                      </div>
                    }
                  </mat-card-content>
                </mat-card>
              </div>

              <!-- Card de disponibilidad (solo eventos técnicos) -->
              @if (
                esEventoTecnico() &&
                getValoresTecnicos()?.disponibilidad?.length
              ) {
                <mat-card class="info-card" appearance="outlined">
                  <mat-card-header>
                    <mat-icon mat-card-avatar>date_range</mat-icon>
                    <mat-card-title>Disponibilidad Horaria</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="rangos-disponibilidad">
                      @for (
                        rango of getValoresTecnicos()?.disponibilidad;
                        track $index
                      ) {
                        <mat-card class="rango-card" appearance="outlined">
                          <mat-card-content>
                            <div class="rango-info">
                              <div class="rango-dias">
                                <mat-icon class="rango-icon">
                                  calendar_today
                                </mat-icon>
                                <span class="rango-text">
                                  {{ getDiasTexto(rango.dias) }}
                                </span>
                              </div>
                              <div class="rango-horario">
                                <mat-icon class="rango-icon">
                                  access_time
                                </mat-icon>
                                <span class="rango-text">
                                  {{ rango.horarioDesde || '00:00' }} -
                                  {{ rango.horarioHasta || '23:59' }}
                                </span>
                              </div>
                            </div>
                          </mat-card-content>
                        </mat-card>
                      }
                    </div>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </div>
        </mat-card-content>

        <!-- Acciones para eventos técnicos -->
        <mat-dialog-actions class="tratamiento-actions">
          @if (tratando && estadoActualTecnico !== 'Finalizado') {
            <!-- Estado: En tratamiento / En Atención -->
            <div class="actions-container tratando">
              <div class="actions-group primary-actions">
                <!-- Agregar nota -->
                <app-button
                  matType="mat-fab extended"
                  color="primary"
                  (click)="agregarNota(); $event.stopPropagation()"
                  text="Agregar nota"
                  icon="add_comment"
                ></app-button>
              </div>

              <div class="actions-group secondary-actions">
                <!-- Finalizar -->
                <app-button
                  matType="mat-fab extended"
                  color="primary"
                  text="Finalizar Servicio Técnico"
                  icon="task_alt"
                  (click)="finalizarTecnico(); $event.stopPropagation()"
                ></app-button>
              </div>
            </div>
          }

          @if (estadoActualTecnico === 'Finalizado') {
            <!-- Estado: Finalizado -->
            <div class="actions-container estado-final">
              <mat-icon class="estado-icon">check_circle</mat-icon>
              <h3 class="estado-mensaje">Servicio Técnico Finalizado</h3>
            </div>
          }
        </mat-dialog-actions>
      }
    }
  </mat-card>
</div>
